
import {Component, Vue} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import {EicraproDurumu, eicraproBekleniyorHatasiMi} from "@/utils/eicraproBaglantisi";
import {BotBeklemeSebebi, botBeklemeGorunurMu} from "@/utils/botBekleme";
import {PlayerDurum} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";

@Component
export default class UyapConnectionInfo extends Vue {
  @Getter isUyapConnected!: boolean;
  @Getter isDevMode!: boolean;
  @Action connectToUyap!: () => Promise<void>;
  @Getter eicraproDurumu!: EicraproDurumu;
  @Getter eicraproDurumMesaji!: string;
  @Getter botBeklemeSebebi!: BotBeklemeSebebi | null;
  @Getter getPlayerDurum!: PlayerDurum;

  get iconColor(): string {
    return this.isUyapConnected ? 'green' : 'white';
  }

  get tooltipText(): string {
    if (this.isUyapConnected) return 'UYAP Bağlantısını yenile.';
    // 'tckn-eksik': lisans doğrulaması kimliği reddetti (TCKN eksik / lisans yok); 'yok': eİcraPro bekleniyor.
    if (this.eicraproDurumu !== 'tamam') {
      return this.eicraproDurumu === 'tckn-eksik' ? this.eicraproDurumMesaji : 'eİcraPro bağlantısı bekleniyor';
    }
    // Durdur'a basılmış bot beklemiyor: bekleme metni yalnız bot çalışırken ('oto') gösterilir.
    return botBeklemeGorunurMu(this.botBeklemeSebebi, this.getPlayerDurum) ? "Bot bekliyor: Uyap'a Bağlan" : "Uyap'a Bağlan";
  }

  handleAction(): void {
    if (this.isUyapConnected) {
      this.openUyap();
    } else {
      // Hata durumu store'da uyapStatusMessage olarak gösteriliyor;
      // burada sadece unhandled rejection engellenir.
      this.connectToUyap().catch((e: unknown) => {
        if (eicraproBekleniyorHatasiMi(e)) {
          this.$toast.info((e as Error).message);
          return;
        }
        console.error('UYAP bağlantısı başarısız.', e);
      });
    }
  }

  openUyap(): void {
    this.$store.dispatch('openUyapWindow');
  }
}
